import { createSlice } from "@reduxjs/toolkit";
import {
  Organization,
  OrganizationCustomer,
  RestaurantPackageOffer,
} from "../../../utils/types";
import { getOrganizationCustomerData } from "../http/getCustomerData";

type InitialState = {
  allOrganizations: Organization[];
  selectedOrganization: Organization | null;
  organizationCustomer: OrganizationCustomer | null;
  organizationCustomerOffers: RestaurantPackageOffer[];
};

const initialState: InitialState = {
  allOrganizations: [],
  selectedOrganization: null,
  organizationCustomer: null,
  organizationCustomerOffers: [],
};

const PartnerAccount = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setSelectedOrganization: (state, { payload }) => {
      state.selectedOrganization = payload;
    },
    setAllOrganizations: (state, { payload }) => {
      state.allOrganizations = payload;
    },
    setOrganizationCustomer: (state, { payload }) => {
      state.organizationCustomer = payload;
    },
    setOrganizationCustomerVerification: (state, { payload }) => {
      if (state.organizationCustomer) {
        state.organizationCustomer.verified = payload;
      }
    },
    setOrganizationCustomerOffers: (state, { payload }) => {
      state.organizationCustomerOffers = payload;
    },
    resetOrganizationCustomer: (state) => {
      state.organizationCustomer = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getOrganizationCustomerData.fulfilled,
      (state, { payload }) => {
        state.organizationCustomer = payload;
      }
    );
  },
});

export const {
  setSelectedOrganization,
  setAllOrganizations,
  setOrganizationCustomer,
  setOrganizationCustomerOffers,
  setOrganizationCustomerVerification,
  resetOrganizationCustomer,
} = PartnerAccount.actions;

export default PartnerAccount.reducer;
